import BaseSVG, { BaseSVGProps } from '../BaseSVG'

export const PlusIcon = (props: BaseSVGProps) => {
  return (
    <BaseSVG viewBox="0 0 16 16" {...props}>
      <path
        d="M7.9987 3.33337V12.6667M3.33203 8.00004H12.6654"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </BaseSVG>
  )
}
